import React, { useEffect, useMemo, useState } from "react";
import { MaterialReactTable } from 'material-react-table';
import { Button, FormControl, Grid, IconButton, ListItemIcon, TextField, Typography } from "@mui/material";
import MenuItem from '@mui/material/MenuItem';
import { AddCircleOutline, Close, DeleteOutline, Edit, Send } from "@mui/icons-material";
import AddAgent from "../components/modals/AddAgent";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { styled } from '@mui/material/styles';
import Header from "../layouts/Header";
import { instance } from "../utils/api";
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { Link } from "react-router-dom";
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));
const cl = 'app-page-ticketlist';

const data = [
  {
    agentName: "John abraham",
    agentEmail: "agent@gmail.com",
    agentPhone: "9900990099",
    numOfTickets: 30,
    numOfTicketsClosed: 30,
  },
];
const Spinner = () => (
  <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 1000 }}>
    <div style={{ width: '40px', height: '40px', borderRadius: '50%', border: '4px solid #ccc', borderTop: '4px solid rgb(255 122 0)', animation: 'spin 1s linear infinite' }}></div>
  </div>
);
function AgentsList() {

  const [apiData, setApiData] = useState([]);
  const [triggerRefresh, setTriggerRefresh] = React.useState(0)
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true)
      try {
        const response = await instance.get("agents/list");
        setApiData(response.data);

        console.log(response.data)
      } catch (error) {
        console.error("Error:", error);
      }
      finally {

        setIsLoading(false);
      }
    }
    fetchData();
  }, [triggerRefresh]);

  const [ticketData, setTicketData] = useState([]);
  const columns = useMemo(
    () => [
      {
        accessorKey: "name",
        header: "Name",
        Cell: ({ renderedCellValue }) => (
          <span className="custom-table-cell-text">{renderedCellValue}</span>
        ),
      },
      {
        accessorKey: "email",
        header: "Email",
        Cell: ({ renderedCellValue }) => (
          <span className="custom-table-cell-text">{renderedCellValue}</span>
        ),
      },
      {
        accessorKey: "phone",
        header: "Phone",
        Cell: ({ renderedCellValue }) => (
          <span className="custom-table-cell-text">{renderedCellValue}</span>
        ),
      },
      {
        accessorKey: "assignedTicketsCount",
        header: "Tickets Assigned",
        Cell: ({ row }) => (
          <Link to={`/ticketsassigned/${row.original.agent_id}`}>
            <Button style={{ padding: "0", minWidth: 'auto' }} className="custom-table-cell-text">{row.original.assignedTicketsCount}</Button>
          </Link>
        ),

      },

      {
        accessorKey: "closedTicketsCount",
        header: "Tickets Closed",
        Cell: ({ row }) => (
          <Link to={`/ticketsclosed/${row.original.agent_id}`}>
            <Button style={{ padding: "0", minWidth: 'auto' }} className="custom-table-cell-text">{row.original.closedTicketsCount}</Button>
          </Link>
        ),
      },
      {
        accessorKey: "status",
        header: "Status",
        Cell: ({ row }) => (
          <span
            className={`custom-table-cell-text ${row.original.is_active ? 'active' : 'inactive'
              }`}
          >
            {row.original.is_active ? 'Active' : 'Inactive'}
          </span>
        ),
      },
    ],
    []
  );




  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setName('');
    setEmail('');

    setPhone('');
    setEditingAgent(null);
  };

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [phone, setPhone] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [editingAgent, setEditingAgent] = useState(null);
  const handleEditClick = async (agentId) => {
    try {

      const response = await instance.get(`agents/${agentId}`);
      const agentDetails = response.data;

      setName(agentDetails.name);
      setEmail(agentDetails.email);
      setPhone(agentDetails.phone);

      setEditingAgent(agentDetails);

      setOpen(true);
    } catch (error) {
      console.error("Error fetching agent details:", error);
    }
  };
  const handleToggleActive = async (agentId, isActive) => {
    try {
      const formData = {
        is_active: isActive ? "true" : "false",
      };

      const response = await instance.put(`agents/update/${agentId}`, formData);

      console.log(response.data);

      setTriggerRefresh(prev => prev + 1);
    } catch (error) {
      console.error("Error toggling active status:", error);
    }
  };
  const [emailError, setEmailError] = useState(false);
  const [phoneError, setPhoneError] = useState(false);

  const handleSaveChanges = async (e) => {
    e.preventDefault();

    try {
      const formData = {
        name: name,
        email: email,
        password: password,
        phone: phone,
      };

      if (!name || !isValidEmail(email) || (!editingAgent && !password) || !isValidPhone(phone)) {
        toast.error('Please fill all required fields with valid data');
        return;
      }
      if (editingAgent) {
        const response = await instance.put(`agents/update/${editingAgent.agent_id}`, formData);
      } else {
        const response = await instance.post("agents/create", formData);
      }

      setTriggerRefresh((prev) => prev + 1);
      handleClose();

      setName('');
      setEmail('');
      setPassword('');
      setPhone('');
      setEditingAgent(null);
    } catch (error) {
      console.error("Error:", error);
      toast.error(error.response.data.error)
    }
  };


  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValid = emailRegex.test(email);
    setEmailError(!isValid);
    return isValid;
  };

  const isValidPhone = (phone) => {
    const phoneRegex = /^[0-9]{10}$/;
    const isValid = phoneRegex.test(phone);
    setPhoneError(!isValid);
    return isValid;
  };

  const updatedColumns = [...columns];
  const actionsColumn = updatedColumns.find((col) => col.accessorKey === "actions");

  if (actionsColumn) {
    updatedColumns.splice(updatedColumns.indexOf(actionsColumn), 1);
    updatedColumns.push(actionsColumn);
  }

  const renderRowActionMenuItems = ({ row, closeMenu }) => [
    <MenuItem key={0} sx={{ m: 0 }} onClick={() => handleEditClick(row.original.agent_id)}>
      <ListItemIcon>
        <Edit />
      </ListItemIcon>
      Edit
    </MenuItem>,
    <MenuItem
      key={1}
      onClick={() => {
        handleToggleActive(row.original.agent_id, !row.original.is_active);
        closeMenu();
      }}
      sx={{ m: 0 }}
    >
      <ListItemIcon>

      </ListItemIcon>
      {row.original.is_active ? 'Mark as Inactive' : 'Mark as Active'}
    </MenuItem>,
  ];






  return (
    <>
      <div className="agents-list">
        <Header />
      </div>
      <div className='app-page-body'>
        <div className='app-page-wrapper'>
          <div className={`${cl}`}>
            <div className={`${cl}__header`}>
              <h2 className={`${cl}__header--title`}>Agents List</h2>
              <ul className={`${cl}__header--actions`}>
                <li className={`${cl}__header--actionsitem`}>
                  <Button variant="contained" onClick={handleClickOpen}><AddCircleOutline /> Add Agent</Button>
                </li>
              </ul>
            </div>
          </div>
          <div className="app-table-component">
            {isLoading ? (

              <Spinner />
            ) : (
              <MaterialReactTable
                columns={updatedColumns}
                data={apiData}
                enableRowActions
                renderRowActionMenuItems={renderRowActionMenuItems}
                positionActionsColumn="last"
                initialState={{ columnPinning: { left: ['name'], } }}
              />

            )}
          </div>
        </div>
      </div>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          {editingAgent ? 'Edit Agent' : 'Add Agent'}
        </DialogTitle>
        <IconButton
          size="small"
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 10,
            top: 14,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Close />
        </IconButton>
        <DialogContent dividers>
          <div>
            <div className={`${cl}`}>
              <div className={`${cl}__card`}>
                <Grid container spacing={3}>
                  <Grid item md={6}>
                    <div className="app-form-fields">
                      <FormControl fullWidth>
                        <TextField
                          size="medium"
                          required
                          id="outlined-basic"
                          label="Phone"
                          placeholder="Enter phone"
                          type="primary"
                          variant="outlined"
                          value={phone}
                          onChange={(e) => {
                            setPhone(e.target.value);
                            setPhoneError(false);
                          }}
                          error={phoneError}
                          helperText={phoneError && "Invalid phone number"}
                        />
                      </FormControl>
                    </div>
                  </Grid>
                  <Grid item md={6}>
                    <div className="app-form-fields">
                      <FormControl fullWidth>
                        <TextField
                          size="medium"
                          required
                          id="outlined-basic"
                          label="Name"
                          placeholder="Enter name"
                          type="primary"
                          variant="outlined"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                        />
                      </FormControl>
                    </div>
                  </Grid>
                  <Grid item md={6}>
                    <div className="app-form-fields">
                      <FormControl fullWidth>
                        <TextField
                          size="medium"
                          required
                          id="outlined-basic"
                          label="Email"
                          placeholder="Enter email"
                          type="primary"
                          variant="outlined"
                          value={email}
                          onChange={(e) => {
                            setEmail(e.target.value);
                            setEmailError(false);
                          }}
                          error={emailError}
                          helperText={emailError && "Invalid email"}
                        />

                      </FormControl>
                    </div>
                  </Grid>
                  <Grid item md={6}>
                    <div className="app-form-fields">
                      <FormControl fullWidth>
                        {editingAgent ? null : (
                          <TextField
                            size="medium"
                            required={!editingAgent}
                            id="outlined-basic"
                            label="Password"
                            placeholder="Enter password"
                            type="password"
                            variant="outlined"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                          />
                        )}
                      </FormControl>
                    </div>
                  </Grid>

                </Grid>
              </div>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>
            Cancel
          </Button>
          <Button type="primary" variant="contained" autoFocus onClick={handleSaveChanges}>
            {editingAgent ? 'Update changes' : 'Save Changes'}
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </>
  )
}
export default AgentsList;
